const DAY_MS = 24 * 60 * 60 * 1000

function parseDateParts(value) {
  const match = String(value || '').match(/^(\d{4})\D+(\d{1,2})\D+(\d{1,2})\D*$/)
  if (!match) return null

  const year = Number(match[1])
  const month = Number(match[2])
  const day = Number(match[3])
  const timestamp = Date.UTC(year, month - 1, day)
  const date = new Date(timestamp)

  if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) {
    return null
  }
  return timestamp
}

function formatChineseDate(timestamp) {
  const date = new Date(timestamp)
  const year = date.getUTCFullYear()
  const month = String(date.getUTCMonth() + 1).padStart(2, '0')
  const day = String(date.getUTCDate()).padStart(2, '0')
  return `${year}年${month}月${day}日`
}

function calculateExpiryDate(productionDate, shelfLifeDays, unit, fallback) {
  const start = parseDateParts(productionDate)
  const days = Number(shelfLifeDays)
  if (unit !== '天' || start === null || !Number.isInteger(days) || days < 1) {
    return fallback || ''
  }
  return formatChineseDate(start + (days - 1) * DAY_MS)
}

module.exports = { calculateExpiryDate }
